import React from 'react'
import { gql, useQuery } from '@apollo/client'
//import { Spinner } from "@/components/ui/spinner";
import {
  MultiSelector,
  MultiSelectorContent,
  MultiSelectorInput,
  MultiSelectorItem,
  MultiSelectorList,
  MultiSelectorTrigger,
} from '@/components/ui/multi-selector'
import { useLanguage } from '@/context/LanguageContext'
const GET_ADDITIONAL_COMPONENT_GROUPS = gql`
  query GET_ADDITIONAL_COMPONENT_GROUPS($language: Language) {
    findManyAdditionalComponentGroup {
      id
      code
      additional_components {
        id
        code
        additionalComponentGroupId
        additional_component_profiles(
          where: { language: { equals: $language } }
        ) {
          name
        }
      }
      additional_component_group_profiles(
        where: { language: { equals: $language } }
      ) {
        name
      }
    }
  }
`

interface AdditionalComponentConstraintsProps {
  field: {
    value: Record<string, { id: number }[]> | undefined
    onChange: (value: any) => void
  }
}

const AdditionalComponentConstraints: React.FC<
  AdditionalComponentConstraintsProps
> = ({ field }) => {
  const { languageId, language } = useLanguage()
  const { data, loading, error } = useQuery(GET_ADDITIONAL_COMPONENT_GROUPS, {
    variables: { language: language },
    fetchPolicy: 'cache-and-network',
  })

  // if (loading) return <Spinner />;
  if (error) return <div>Error loading component groups.</div>

  return (
    <>
      {data?.findManyAdditionalComponentGroup?.map((group: any) => (
        <div key={group.id} style={{ width: '100%' }}>
          <MultiSelector
            values={
              field.value?.[group.id]?.map((item: { id: number }) => ({
                id: item.id.toString(),
                name:
                  group.additional_components.find((c: any) => c.id === item.id)
                    ?.additional_component_profiles[0]?.name || '',
              })) || []
            }
            onValuesChange={values => {
              const newValue = { ...field.value }
              newValue[group.id] = values.map(item => ({
                id: Number(item.id),
              }))
              field.onChange(newValue)
            }}
            loop
            className="max-w-fulld"
          >
            <MultiSelectorTrigger>
              <MultiSelectorInput
                placeholder={
                  group.additional_component_group_profiles?.[0]?.name || ''
                }
              />
            </MultiSelectorTrigger>
            <MultiSelectorContent>
              <MultiSelectorList>
                {group.additional_components.map((component: any) => (
                  <MultiSelectorItem
                    key={component.id}
                    value={{
                      id: component.id.toString(),
                      name:
                        component.additional_component_profiles[0]?.name || '',
                    }}
                  >
                    {component.additional_component_profiles[0]?.name}
                  </MultiSelectorItem>
                ))}
              </MultiSelectorList>
            </MultiSelectorContent>
          </MultiSelector>
        </div>
      ))}
    </>
  )
}

export default AdditionalComponentConstraints
